import React from "react";

import { IStringField } from "../models/formFields";
import { isMobile } from "../utils/detectMobile";
import { FormInput } from "./FormInput";

export const FormCreditCardNumberInput = <T extends string>(
    props: IStringField<T>,
): React.JSX.Element => {
    // Due to issues with Cleave.js on Android, disable number grouping there.
    const isAndroid = isMobile.Android();
    const newProps: IStringField<T> = {
        type: "text",
        validation: ["required", "credit-card"],
        autoComplete: "cc-number",
        formatOptions: isAndroid
            ? undefined
            : {
                  type: "credit-card",
              },
        maxLength: 24,
        ...props,
        // If Android and there's a value, strip spaces
        value:
            isAndroid && props.value
                ? props.value.replace(/\s+/g, "")
                : props.value,
    };
    return <FormInput {...newProps} />;
};
